"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var useCanSSR = function useCanSSR() {
  // we always start off in "SSR mode", to ensure our initial browser render
  // matches the SSR render
  var _useState = (0, _react.useState)(true),
      isSsr = _useState[0],
      setIsSsr = _useState[1];

  (0, _react.useEffect)(function () {
    // `useEffect` never runs on the server, so we must be on the client if
    // we hit this block
    setIsSsr(false);
  }, []);
  return isSsr;
};

var _default = useCanSSR;
exports.default = _default;